import { APP_LANGUAGES, type Language } from "@/types";

const VALID_LANGS = new Set<string>(APP_LANGUAGES.map((l) => l.code));

export function isAppLang(lang: string | undefined): lang is Language {
  return !!lang && VALID_LANGS.has(lang);
}

/**
 * Normaliza cualquier tag BCP-47 del detector de i18next ("en-US", "pt-BR",
 * "es-AR"…) al locale base soportado. i18n.language conserva el tag crudo del
 * navegador; usarlo como segmento de URL rompía la home (/en-US/ no matchea
 * ninguna ruta → página en blanco). Fallback: idioma default de la app.
 */
export function normalizeAppLang(raw: string | undefined): Language {
  if (isAppLang(raw)) return raw;
  const base = raw?.toLowerCase().split("-")[0];
  if (isAppLang(base)) return base;
  return APP_LANGUAGES[0].code;
}
